import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import PartnerReferralDetailsCard from './PartnerReferralDetailsCard';
import PartnerReferralTableRecord from './PartnerReferralTableRecord';
import GoBackIcon from '../../svgs/GoBackIcon';

import Styles from './PartnerDetails.module.scss';

const PartnerDetails = () => {
  const { push } = useHistory();
  const { partnerId } = useParams<{ partnerId: string }>();
  const [referralId, setReferralId] = useState(null);
  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__title}>
          <span>
            <GoBackIcon
              onClick={() => push('/rewards/partners-tracking-code?page=1')}
            />
            Partner's Tracking Code
          </span>
        </div>
        <PartnerReferralDetailsCard
          rewardId={partnerId}
          setReferralId={(data) => setReferralId(data)}
        />
        <PartnerReferralTableRecord referralId={referralId} />
      </div>
    </DashboardWrap>
  );
};

export default PartnerDetails;
